var map = {
	"./brain.selected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/brain.selected.png",
	"./brain.unselected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/brain.unselected.png",
	"./female.selected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/female.selected.png",
	"./female.unselected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/female.unselected.png",
	"./flower_parts.selected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/flower_parts.selected.png",
	"./flower_parts.unselected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/flower_parts.unselected.png",
	"./male.selected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/male.selected.png",
	"./male.unselected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/male.unselected.png",
	"./whole_plant.selected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/whole_plant.selected.png",
	"./whole_plant.unselected.png": "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img/whole_plant.unselected.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/@ebi-gene-expression-group/anatomogram/lib/img sync recursive ^\\.\\/.*selected\\.png$";